import moment from 'moment';
import { isProduction } from '../../constants/environment';

export const maintenanceError = new Error('In Maintenance');

const preventCallbackIfInMaintenance = (state, callback) => {
  const {
    apiConnectivity: { maintenanceUntil },
  } = state;
  const now = moment();

  if (!isProduction || !maintenanceUntil || now.isAfter(maintenanceUntil)) {
    return callback();
  }

  return Promise.reject(maintenanceError);
};

export default preventCallbackIfInMaintenance;



// WEBPACK FOOTER //
// ../utils/functions/maintenance-check/index.js